import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

//
// RE detecting turbo stream connection, see this GitHub issue:
// https://github.com/hotwired/turbo-rails/issues/498
//
export default class extends Controller {
  static values = {
    refreshPath: String,
  };

  async connect() {
    if (this.refreshPathValue) {
      this.observer = new MutationObserver(() => this.updateStatus());
      this.observer.observe(this.element, {
        attributes: true,
        attributeFilter: ["connected"],
      });

      await this.updateStatus();
    }
  }

  disconnect() {
    this.observer?.disconnect();
  }

  async updateStatus() {
    if (this.element.hasAttribute("connected")) {
      await post(this.refreshPathValue);
      this.disconnect();
    }
  }
}
